import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useFormStyles } from './form-styles'
import { color } from './tokens'
import { achMandateText } from './ach'

const useMandateStyles = makeStyles({
  mandate: { margin: 0, fontSize: 12, lineHeight: '16px', color: color.mutedForeground }
})

// Stripe's ACH debit authorization, shown above Pay for any bank payment.
export const BankMandate: FC<{ amount: string }> = ({ amount }) => (
  <p
    className={useMandateStyles().mandate}
    data-testid='cellular-ach-mandate'
  >
    {achMandateText(amount)}
  </p>
)

interface BankAccountFormProps {
  holderName: string
  amount: string
  disabled?: boolean
  onChange: (name: string) => void
}

// Adding a bank account: only the account holder's name is ours. The bank login
// (or typed routing and account numbers) happens in Stripe's own window when the
// customer presses Pay, so no bank detail ever touches our code.
export const BankAccountForm: FC<BankAccountFormProps> = ({ holderName, amount, disabled, onChange }) => {
  const classes = useFormStyles()
  return (
    <div className={classes.fields}>
      <div className={`${classes.field} ${classes.wide}`}>
        <label
          className={classes.label}
          htmlFor='cellular-bank-holder'
        >
          Account holder name
        </label>
        <input
          autoComplete='name'
          className={classes.input}
          disabled={disabled}
          id='cellular-bank-holder'
          maxLength={100}
          onChange={event => onChange(event.target.value)}
          placeholder='Jane Doe or Your School District'
          value={holderName}
        />
      </div>
      <div className={classes.wide}>
        <p className={classes.optionSub}>
          When you press Pay, Stripe opens a window to log in to your bank. If your bank is not
          listed, you can enter your routing and account numbers instead; Stripe then sends two
          small deposits to confirm the account (1–2 business days). Bank payments take 3–5
          business days to clear, and your service stays on meanwhile.
        </p>
      </div>
      <div className={classes.wide}>
        <BankMandate amount={amount} />
      </div>
    </div>
  )
}
